module.exports = "/static-assets/_next/static/images/light-bulb-1335467ba083e52459e263951df0b94c.png";